import { render } from "./WafDialogWrapper.vue?vue&type=template&id=d75bb632&ts=true"
import script from "./WafDialogWrapper.vue?vue&type=script&lang=ts"
export * from "./WafDialogWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__